import { createSlice } from '@reduxjs/toolkit'

import { previewInvoiceForLiveChatSeats } from 'common/billing/actions/billingAuxiliaryActions'
import { DEFAULT_FULL_PREVIEW_INVOICE } from 'common/billing/entities/previewInvoice/constants'
import { PreviewInvoiceState } from 'common/billing/entities/previewInvoice/interfaces'

const initialState: PreviewInvoiceState = {
  isLoading: false,
  previewInvoice: DEFAULT_FULL_PREVIEW_INVOICE,
}

export const previewInvoiceSlice = createSlice({
  name: 'previewInvoice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(previewInvoiceForLiveChatSeats.pending, (state) => {
        state.isLoading = true
      })
      .addCase(previewInvoiceForLiveChatSeats.fulfilled, (state, action) => {
        state.isLoading = false
        state.previewInvoice = action.payload
      })
      .addCase(previewInvoiceForLiveChatSeats.rejected, (state) => {
        state.isLoading = false
      })
  },
})
